function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Coordinate from '../geom/Coordinate';
import Comparable from '../../../../java/lang/Comparable';
var EdgeIntersection = /*#__PURE__*/function () {
  function EdgeIntersection() {
    _classCallCheck(this, EdgeIntersection);
    EdgeIntersection.constructor_.apply(this, arguments);
  }
  return _createClass(EdgeIntersection, [{
    key: "getSegmentIndex",
    value: function getSegmentIndex() {
      return this.segmentIndex;
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      return this.coord;
    }
  }, {
    key: "print",
    value: function print(out) {
      out.print(this.coord);
      out.print(' seg # = ' + this.segmentIndex);
      out.println(' dist = ' + this.dist);
    }
  }, {
    key: "compareTo",
    value: function compareTo(obj) {
      var other = obj;
      return this.compare(other.segmentIndex, other.dist);
    }
  }, {
    key: "isEndPoint",
    value: function isEndPoint(maxSegmentIndex) {
      if (this.segmentIndex === 0 && this.dist === 0.0) return true;
      if (this.segmentIndex === maxSegmentIndex) return true;
      return false;
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.coord + ' seg # = ' + this.segmentIndex + ' dist = ' + this.dist;
    }
  }, {
    key: "getDistance",
    value: function getDistance() {
      return this.dist;
    }
  }, {
    key: "compare",
    value: function compare(segmentIndex, dist) {
      if (this.segmentIndex < segmentIndex) return -1;
      if (this.segmentIndex > segmentIndex) return 1;
      if (this.dist < dist) return -1;
      if (this.dist > dist) return 1;
      return 0;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return EdgeIntersection;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Comparable];
    }
  }]);
}();
export { EdgeIntersection as default };
EdgeIntersection.constructor_ = function () {
  this.coord = null;
  this.segmentIndex = null;
  this.dist = null;
  var coord = arguments[0];
  var segmentIndex = arguments[1];
  var dist = arguments[2];
  this.coord = new Coordinate(coord);
  this.segmentIndex = segmentIndex;
  this.dist = dist;
};